<template>
  <div class="card-header">
    <div class="header-top">
      <div class="resource_icon">
        <i class="bi bi-layers-fill" />
      </div>
      <div class="resource_format">
        {{ resource.type }}
      </div>
      <div class="resource_name">
        {{ resource.name }}
      </div>
    </div>
    <div class="header-bottom">
      <slot name="publication" />
    </div>
  </div>
</template>

<script>



export default {
  name: 'GeoserverEditor',

  components: {
  },

  props: {
    isMain: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      loading: false,
    };
  },

  computed: {
  },

  methods: {
  
  }
};
</script>

<style lang="less" scoped>

</style>